import {
	AfterContentInit,
	Component,
	ElementRef,
	EventEmitter,
	forwardRef,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IdService, FormControlBase } from '../../shared/index';
import { ICheckboxUpdateEvent } from './checkbox.types';
import { fromEvent, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
	selector: 'rbc-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => CheckboxComponent)
		}
	]
})
export class CheckboxComponent extends FormControlBase<boolean> implements OnDestroy, OnChanges, AfterContentInit {
	@Input() disabled: boolean;
	@Input() id: string;
	@Input() name: string;
	@Input() ariaLabel: string;
	@Input() ariaLabelledBy: string;
	@Input() model: string | boolean = false;
	@Output() modelChange = new EventEmitter<string | boolean>();
	@Output() checkBoxUpdate = new EventEmitter<ICheckboxUpdateEvent>(); // id and checked state object
	@ViewChild('checkbox') checkboxRef: ElementRef;
	@ViewChild('checkboxWrap') checkboxWrap: ElementRef;

	mouseoutObservable: Observable<any>;

	constructor(private idService: IdService) {
		super();
		this.id = idService.generate();
	}

	ngAfterContentInit(): void {
		this.writeValue(this.innerValue);
	}

	ngOnChanges(changes: SimpleChanges) {
		super.ngOnChanges(changes);

		if (changes && changes.model) {
			this.writeValue(changes.model.currentValue);
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		super.ngOnDestroy();
	}

	toggleHandler() {
		const isSelected = !this.innerValue;
		this.setModel(isSelected);
		this.modelChange.emit(isSelected);
		this.checkBoxUpdate.emit({ id: this.id, checked: isSelected });

		if (!this.mouseoutObservable) {
			this.mouseoutObservable = fromEvent(this.checkboxWrap.nativeElement, 'mouseout');

			this.mouseoutObservable.pipe(take(1)).subscribe(this.removeFocus.bind(this));
		}
	}

	removeFocus() {
		this.checkboxRef.nativeElement.blur();
		this.mouseoutObservable = null;
	}
}
